<mat-card appearance="outlined">
    <app-vinavon-button>
        <button (click)="createRapport()" [disabled]="!(canCreateRapport | async)" mat-raised-button>
            <mat-icon>note_add</mat-icon>
            {{ "Rapport erstellen" }}
        </button>

        <button (click)="showRapport()" [disabled]="!(canCreateMailRapport$ | async)" mat-raised-button>
            <mat-icon>find_in_page</mat-icon>
            {{ "Rapport anzeigen" }}
        </button>

        <button (click)="createMailWithRapport()" [disabled]="!(canCreateMailRapport$ | async)" mat-raised-button>
            <mat-icon>outgoing_mail</mat-icon>
            {{ "Mail erstellen" }}
        </button>
    </app-vinavon-button>

    <div *ngIf="this.currTermin" class="container" style="display: flex; flex-direction: column; gap: 0.5em;">
        <div *ngIf="isManuDescRichText() === false">
            {{ "MAIN_APP_SERVICE_APP.auftrag" | translate }}:
            {{ this.currTermin!.objectNumber }} {{ this.currTermin!.objDescription }}
            <br/>
            {{ "MAIN_APP_SERVICE_APP.objekt" | translate }}:
            {{ this.currTermin!.note4 }} <br/>
            {{ "MAIN_APP_SERVICE_APP.arbeitsbeschrieb" | translate }}:
            {{ this.currTermin!.manufacturingDescription }} <br/>
            {{ "MAIN_APP_SERVICE_APP.zusätzlicheArbeiten" | translate }}:
            {{ this.currTermin!.additionalWork }} <br/>
        </div>

        <div (window:resize)="onResize($event)" *ngIf="isManuDescRichText() === true">
            <table class="report-data">
                <tr>
                    <td>{{ "MAIN_APP_SERVICE_APP.auftrag" | translate }}:</td>
                    <td>
                        {{ this.currTermin!.objectNumber }}
                        {{ this.currTermin!.objDescription }}
                    </td>
                </tr>
                <tr>
                    <td>{{ "MAIN_APP_SERVICE_APP.objekt" | translate }}:</td>
                    <td>{{ this.currTermin!.note4 }}</td>
                </tr>
                <tr>
                    <td>{{ "MAIN_APP_SERVICE_APP.arbeitsbeschrieb" | translate }}:</td>
                    <td>
                        <ejs-richtexteditor #richTxtManuDesc
                                            [readonly]="true"
                                            [toolbarSettings]="{enable:false}"
                                            [value]="currTermin.manufacturingDescription"
                        ></ejs-richtexteditor>
                    </td>
                </tr>
                <tr>
                    <td>{{ "MAIN_APP_SERVICE_APP.zusätzlicheArbeiten" | translate }}:</td>
                    <td>{{ this.currTermin!.additionalWork }}</td>
                </tr>
            </table>
        </div>


        <ejs-grid #gridRapport (load)='load()' [dataSource]="rapportZeilen">
            <e-columns>
                <e-column [visible]="false" field="servicePosID" headerText="ID" width="0"></e-column>
                <e-column field="datum" headerText="Datum" textAlign="Right" width="110"></e-column>
                <e-column field="mitarbeiter" headerText="Mitarbeiter" textAlign="Left"></e-column>
                <e-column field="bezeichnung" headerText="Bezeichnung" textAlign="Left"></e-column>
                <e-column field="menge" headerText="Menge" textAlign="Left" width="120"></e-column>
                <e-column field="einheit" headerText="Einheit" textAlign="Left" width="120"></e-column>
                <e-column field="preis" headerText="Einzelpreis" textAlign="Right" width="130"></e-column>
                <e-column field="preisTotal" headerText="Preis" textAlign="Right" width="130"></e-column>
                <e-column field="spesen" headerText="Spesen" textAlign="Center">
                    <ng-template #template let-data>
                        <img alt="img" src="/assets/images/{{ imgSrc(data.spesen) }}" style="width: 16px; height: 16px"/>
                    </ng-template>
                </e-column>
                <e-column field="kulanz" headerText="Kulanz" textAlign="Center">
                    <ng-template #template let-data>
                        <img alt="img" src="/assets/images/{{ imgSrc(data.kulanz) }}" style="width: 16px; height: 16px"/>
                    </ng-template>
                </e-column>
            </e-columns>
            <e-aggregates>
                <e-aggregate>
                    <e-columns>
                        <e-column columnName="preis" type="Custom">
                            <ng-template #footerTemplate let-data>Total exkl.</ng-template>
                        </e-column>
                        <e-column [customAggregate]="customAggregateTotalExkl" columnName="preisTotal" type="Custom">
                            <ng-template #footerTemplate let-data>{{
                                    data.Custom
                                }}
                            </ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
                <e-aggregate>
                    <e-columns>
                        <e-column columnName="preis" type="Custom">
                            <ng-template #footerTemplate let-data>{{ mwstSatz }}% MwSt.</ng-template>
                        </e-column>
                        <e-column [customAggregate]="customAggregateMwSt" columnName="preisTotal" type="Custom">
                            <ng-template #footerTemplate let-data>{{
                                    data.Custom
                                }}
                            </ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
                <e-aggregate>
                    <e-columns>
                        <e-column columnName="preis" type="Custom">
                            <ng-template #footerTemplate let-data>Total inkl.</ng-template>
                        </e-column>
                        <e-column [customAggregate]="customAggregateTotalInkl" columnName="preisTotal" type="Custom">
                            <ng-template #footerTemplate let-data>{{
                                    data.Custom
                                }}
                            </ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
            </e-aggregates>
        </ejs-grid>

        <ng-container *ngIf="!(canCreateMailRapport$ |async)">
            <div>
                <form [formGroup]="formGroupRapport">
                    <mat-checkbox (change)="setJobDone($event.checked)" formControlName="fldJobDone">{{
                            "MAIN_APP_SERVICE_APP.auftragFertigErledigtDurch" | translate
                        }}<b>{{ mitarbeiter }}</b></mat-checkbox>
                </form>
            </div>

            <div>
                <canvas #sigCanvas height="150" style="background: url('src/assets/images/signature.png')" width="800"></canvas>
                <app-vinavon-button>
                    <button (click)="clearSignature()" mat-raised-button>
                        <mat-icon>delete</mat-icon>
                        {{ "MAIN_APP_SERVICE_APP.unterschriftLöschen" | translate }}
                    </button>
                </app-vinavon-button>

            </div>
        </ng-container>

    </div>
</mat-card>
